import { useEffect, useState } from "react";
import {
    Box, CssBaseline, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
    Grid, Button, IconButton, List, ListItem, ListItemAvatar, ListItemText, Tooltip, Typography
} from "@mui/material";
import MetaDecorator from "../services/meta_decorator";
import { Navigate, useParams } from "react-router-dom";
import { getApiUrl } from "../services/api_service";
import { Alert } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import LinearProgress from '@mui/material/LinearProgress';
import NDReferralHeader from "../components/shared/ndreferralheader";
import dayjs from "dayjs";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Footer from "../components/shared/footer";
import { blackcolor, bodyBg, darkcolor, footerContainer, fullHeight, headerText, mainGrid, pcolor, rcolor, whitecolor } from "../style2";

export default function ReferralPatients() {
    const { orgCode } = useParams();
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState([]);
    const [redirect, setRedirect] = useState('');
    const [showRemovePopup, setShowRemovePopup] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const headerCellCss = { fontSize: "1.1rem", color: pcolor }

    const [canMakeReferral, setCanMakeReferral] = useState(false);
    const rowCellCss = { fontSize: "1rem", color: blackcolor }


    useEffect(() => {
        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;

            setCanMakeReferral(parsedAuthTokens?.userType === "1" || parsedAuthTokens?.userType === 1);
        }
        if (!token) {
            setRedirect(`/login/${orgCode}`);
            return;
        }
        setError('');
        setSuccess('');
        setLoading(true);
        fetch(`${getApiUrl()}/referralapp/patientlist?code=${orgCode}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        })
            .then(response => {
                if (response.status === 200) {

                    response.json().then(data => {
                        setResult(data);
                    });
                }
                else if (response.status === 401 || response.status === 403) {
                    setRedirect(`/login/${orgCode}`);
                }
                else {
                    response.json().then(data => {
                        setError(data.error);
                    }).catch(err => {
                        console.log(err);
                        setError("Unable to process request.");
                    })
                }
            }).catch(err => {
                console.log(err);
                setError("Unable to contact server.");
            }).finally(() => {
                setLoading(false);
            })
    }, []);

    const removePatientFunc = () => {
        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        if (!token) {
            setRedirect(`/login/${orgCode}`);
            return;
        }
        setError('');
        setSuccess('');
        setLoading(true);
        fetch(`${getApiUrl()}/referralapp/removepatient?code=${orgCode}&id=${selectedId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        })
            .then(response => {
                if (response.status === 200) {
                    setResult([...result.filter(t => t.id !== selectedId)]);
                    setShowRemovePopup(false);
                    setSelectedId(null);
                }
                else {
                    response.json().then(data => {
                        setError(data.error);
                        console.log(data);
                    }).catch(err => {
                        console.log(err);
                        setError("Unable to process request.");
                    })
                }
            }).catch(err => {
                console.log(err);
                setError("Unable to contact server.");
            }).finally(() => {
                setLoading(false);
            })
    }

    if (redirect !== "")
        return <Navigate to={redirect} replace />
    else
        return <Box sx={{ ...bodyBg, ...fullHeight }}>
            <CssBaseline />
            <MetaDecorator title={"EnrichMyCare - Make A Referral"} description={"EnrichMycare Make Refferal"} />
            <NDReferralHeader orgCode={orgCode} logo="../../logo.jpg" />
            <Box pt={1} sx={{ ...bodyBg, marginTop: "5px", minHeight: "80vh" }} p={5}>
                <Grid container sx={{ flexGrow: 1 }} spacing={0}>
                    <Grid size={6} item>
                        <Typography variant="h5" sx={{ ...headerText, marginTop: "15px", fontWeight: "bold", fontSize: "1.5rem" }}>School / SENCO’S Referrals</Typography>
                    </Grid>
                    <Grid size={6} item>
                        {result.length > 0 && canMakeReferral ? <Box mb={1} mt={2} style={{ textAlign: "right" }}>
                            <Button onClick={() => { setRedirect(`/screenprocess/${orgCode}`); }}
                                style={{ border: `1px solid ${rcolor}`, background: rcolor, color: whitecolor, fontSize: "1.1rem", height: "40px", borderRadius: 2 }}>Make a referral</Button>
                        </Box> : null}
                    </Grid>
                </Grid>

                <Box sx={{ ...mainGrid, marginTop: "20px", padding: "0px", border: "none" }}>
                    {error !== "" ? <Box mb={1} mt={1}><Alert severity="error">{error}</Alert></Box> : null}
                    {success !== "" ? <Box mb={1} mt={1}><Alert severity="success">{success}</Alert></Box> : null}
                    <table cellPadding={0} cellSpacing={0} style={{ width: "100%", borderRadius: "10px", border: "none" }}>
                        <thead>
                            <tr style={{ height: "50px", background: "#E7E7E7", borderRadius: "5px" }}>
                                <th align="left" style={{ ...headerCellCss, paddingLeft: 10 }}>
                                    <Tooltip title="NHS Number"><Box>Patient Details <InfoOutlinedIcon style={{ fontSize: "1rem" }} /></Box></Tooltip></th>

                                <th align="left" style={headerCellCss}>Parent/Carer Forms</th>
                                <th align="left" style={headerCellCss}>Referrar Forms</th>
                                <th align="left" style={headerCellCss}>Registration Date</th>
                                <th style={headerCellCss}>Referral Status</th>
                                <th style={headerCellCss}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {result.map((item, index) => {
                                return <tr key={index} className="referral-table-row" style={{ height: "50px", cursor: "pointer" }}>
                                    <td align="left" style={{ ...rowCellCss, paddingLeft: 10 }} onClick={() => { setRedirect(`/details/${orgCode}/${item.id}`); }}>
                                        <Box sx={{ pb: 1 }}><strong>Name:</strong> <span style={{ textTransform: "capitalize" }}>{item.name}</span></Box>
                                        <Box sx={{ pb: 1 }}><strong>NHS Number:</strong> {item.nhsNumber}</Box>
                                        <Box sx={{ pb: 1 }}><strong>DOB:</strong> {dayjs(item.dob).format("DD/MM/YYYY")}</Box>
                                        
                                    </td>

                                    <td style={rowCellCss} onClick={() => { setRedirect(`/details/${orgCode}/${item.id}`); }}>{item.parentForms !== null ?
                                        <List sx={{ width: '100%', maxWidth: 360 }}>
                                            {
                                                item.parentForms.map(item => {
                                                    return <ListItem style={{ padding: "5px" }}>
                                                        {item.status === 1 ? <ListItemAvatar style={{ minWidth: "35px" }}>
                                                            <CheckCircleOutlineIcon title="Form Assigned" sx={{ color: rcolor }} />
                                                        </ListItemAvatar> : null}
                                                        {item.status === 2 ? <ListItemAvatar style={{ minWidth: "35px" }}>
                                                            <CheckCircleOutlineIcon color="info" title="Form InProgress" />
                                                        </ListItemAvatar> : null}
                                                        {item.status === 3 || item.status === 4 ? <ListItemAvatar style={{ minWidth: "35px" }}>
                                                            <CheckCircleOutlineIcon title="Submitted/Complete" color="success" />
                                                        </ListItemAvatar> : null}
                                                        <ListItemText primary={item.title} secondary="" />
                                                    </ListItem>;
                                                })
                                            }
                                        </List> : null}</td>
                                    <td style={rowCellCss} onClick={() => { setRedirect(`/details/${orgCode}/${item.id}`); }}>
                                        {item.referrerForms !== null ? <List sx={{ width: '100%', maxWidth: 360, }}>
                                            {
                                                item.referrerForms.map(item => {
                                                    return <ListItem style={{ padding: "5px" }}>
                                                        {item.status === 1 ? <ListItemAvatar style={{ minWidth: "35px" }}>
                                                            <CheckCircleOutlineIcon title="Form Assigned" sx={{ color: rcolor }} />
                                                        </ListItemAvatar> : null}
                                                        {item.status === 2 ? <ListItemAvatar style={{ minWidth: "35px" }}>
                                                            <CheckCircleOutlineIcon color="info" title="Form InProgress" />
                                                        </ListItemAvatar> : null}
                                                        {item.status === 3 || item.status === 4 ? <ListItemAvatar style={{ minWidth: "35px" }}>
                                                            <CheckCircleOutlineIcon title="Submitted/Complete" color="success" />
                                                        </ListItemAvatar> : null}
                                                        <ListItemText primary={item.title} secondary="" />
                                                    </ListItem>;
                                                })
                                            }
                                        </List> : null}
                                    </td>
                                    <td style={rowCellCss} onClick={() => { setRedirect(`/details/${orgCode}/${item.id}`); }}>{dayjs(item.createDate).format("DD/MM/YYYY")}</td>
                                    <td align="center" style={rowCellCss} onClick={() => { setRedirect(`/details/${orgCode}/${item.id}`); }}>
                                        <Box p={1}>
                                            {item.referralStatus > 0 ? <LinearProgress variant="determinate" style={{ height: "20px", borderRadius: "20px" }} value={item.referralStatus} color={item.isReferralComplete ? "success" : "primary"} /> : <Typography style={{ color: "rgb(233, 30, 99)" }}>Not Started</Typography>}
                                        </Box>
                                    </td>
                                    <td align="center" style={rowCellCss}>
                                        <IconButton disabled={loading}
                                            aria-label='delete'
                                            onClick={() => {
                                                setSelectedId(item.id);
                                                setShowRemovePopup(true);
                                            }}
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                    </td>
                                </tr>
                            })}
                            {!loading && result.length === 0 ? (
                                <tr>
                                    <td colSpan={10} align="center">
                                        <Box sx={{ pt: 5, pb: 2 }}>
                                            You currently have no referrals in your caseload list.

                                        </Box>
                                        {canMakeReferral ? <Button
                                            variant="text"
                                            sx={{ mb: 5, border: `1px solid ${rcolor}`, background: rcolor, color: whitecolor, fontSize: "1.1rem", height: "40px", borderRadius: 2 }}
                                            onClick={() => setRedirect(`/screenprocess/${orgCode}`)}
                                        >
                                            MAKE A REFERRAL
                                        </Button> : null}
                                    </td>
                                </tr>
                            ) : null}
                        </tbody>
                    </table>
                    {loading ? <Box pt={1} pb={2} sx={{ textAlign: "center" }}><Typography>Loading Forms...</Typography></Box> : null}
                    <Dialog
                        open={showRemovePopup}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description">
                        <DialogTitle id="alert-dialog-title">
                            Delete Referral
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                <div style={{
                                    color: darkcolor,
                                    fontSize: "1.125em",
                                    fontWeight: "400",
                                    lineHeight: "normal",
                                    textAlign: "center",
                                    wordWrap: "break-word",
                                    wordBreak: "break-word", maxWidth: "500px", marginTop: "20px"
                                }}>
                                    Are you sure you want to delete this patient referral?<br /><br />
                                    This action is permanent and cannot be undone.</div>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions >
                            <Button type="button" disabled={loading} style={{
                                marginBottom: "20px", backgroundColor: darkcolor, color: whitecolor, borderRadius: "9px", marginRight: "20px",
                                width: "80px"
                            }} onClick={() => { removePatientFunc(); }} autoFocus>
                                Ok
                            </Button> <Button type="button" disabled={loading} style={{
                                marginBottom: "20px", backgroundColor: darkcolor, color: whitecolor, borderRadius: "9px",

                            }} onClick={() => { setSelectedId(null); setShowRemovePopup(false); }} autoFocus>
                                Cancel
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Box>
            </Box>
            <Box style={{ ...footerContainer, position: "static" }}>
                <Footer />
            </Box>
        </Box>
}